import { reduxBatch } from '@manaflair/redux-batch'
import {
  APPLICATION_TYPES,
  APPLICATION_TYPES_VALUE,
  BUILDING_CODE,
  CORROSION_RESISTANCE_VALUE,
  OVERHANG_LENGTH,
  ROOF_MEMBER_TYPES,
} from '../../common/constants'
import { getInputErrors } from '../slices/selectors'
import { resultActions, uiActions } from '../slices'
import { calcPitch, toDegree, numberFormatted } from '../../../../utils/fns'

export const inputToQuery = (input) => {
  const { jobSettings, wall, roof, settings } = input
  const loads = Object.assign(
    {},
    {
      f1: jobSettings.f1,
      f2Toward: jobSettings.f2,
      f2Away: jobSettings.f2Away,
      uplift: jobSettings.uplift,
      upliftLoadDurationType: jobSettings.upliftLoadDurationType,
    },
    wall.applicationType === APPLICATION_TYPES.PERPENDICULAR_TO_WALL && {
      download: jobSettings.download,
      downloadDurationType: jobSettings.downloadDurationType,
    },
    wall.applicationType === APPLICATION_TYPES.PARALLEL_TO_WALL && {
      f1: Math.round((jobSettings.f1 * jobSettings.wallLength) / 12),
      uplift: Math.round((jobSettings.uplift * jobSettings.wallLength) / 12),
      f2Toward: Math.round((jobSettings.f2 * jobSettings.wallLength) / 12),
      f2Away: Math.round((jobSettings.f2Away * jobSettings.wallLength) / 12),
    },
  )

  const rafter = Object.assign(
    {},
    {
      ply: roof.ply,
      topSlope: toDegree(calcPitch(roof.topSlope)),
      type: roof.type,
      width: roof.width,
      flangeThickness: 0,
      topDepth: roof.topChordDepth,
    },
    roof.memberType === ROOF_MEMBER_TYPES.IJOIST && {
      flangeThickness: roof.thickness,
    },
    roof.memberType === ROOF_MEMBER_TYPES.TRUSS && {
      bottomDepth: roof.bottomChordDepth,
      kingDepth: roof.endVerticalDepth,
      bottomSlope: toDegree(calcPitch(roof.bottomSlope)),
    },
  )

  const wallData = Object.assign(
    {},
    {
      height: wall.topPlateThickness,
      length:
        wall.applicationType === APPLICATION_TYPES.PARALLEL_TO_WALL
          ? Number(jobSettings.wallLength)
          : 0,
      type: wall.type,
      width: wall.topPlateWidth,
    },
    wall.isStudMember && { ply: wall.topPlatePlies },
  )

  const query = {
    buildingCode: BUILDING_CODE[settings.country],
    filters: {
      corrosionProtectionLevel:
        CORROSION_RESISTANCE_VALUE[jobSettings.corrosionResistance.toUpperCase()],
      filterTie: 0,
      rafterFastener: 0,
      series: '',
      wallFastener: 0,
    },
    loads: numberFormatted(loads),
    manufacturer: 0,
    rafter,
    rafterInstallation: {
      bottomCantilever: roof.overhang,
      heel: Number(roof.heel),
      overhangLength: roof.overhang ? OVERHANG_LENGTH : 0,
      studAlignment:
        wall.applicationType !== APPLICATION_TYPES.PERPENDICULAR_TO_WALL
          ? true
          : wall.studAlignment,
      wallAlignment: APPLICATION_TYPES_VALUE[wall.applicationType.toUpperCase()],
    },
    sort: 9,
    wall: wallData,
  }

  const formattedValues = numberFormatted(query)

  return formattedValues
}

const calculationOutputData = ({ dispatch, getState }) => {
  // const access_token =  cookies.set(APP_TOKEN_KEY)
  const query = inputToQuery(getState().calculation.input)
  // if (access_token) {
  reduxBatch([
    // dispatch(resultActions.createOutputQuery(query)),
    dispatch(resultActions.getHurricaneTiesData(query)),
    dispatch(resultActions.setSelectedModel(null)),
  ])
  // }
}

const createQuery = (store) => (next) => (action) => {
  next(action)

  const inputErrors = getInputErrors(store.getState())

  if (uiActions.updateInputErrors.match(action) && inputErrors === null)
    calculationOutputData(store)
}

export default createQuery
